
/*
Defines the custom element <ravel-crank>
*/

import { RavelCrank } from './src/RavelCrank.js';

customElements.define('ravel-crank', RavelCrank);
